
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.circle   = json.circle
      this.title    = json.title
      this.summary  = json.summary
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      this.angle = {
        size: 180,
        start: 270,
        end: 450
      }

    },
  }
}